import { observable } from 'mobx';
import useMount from '@src/utils/hooks/use-mount';
import createHtmlLink from '@src/utils/create-html-link';

class AuditionStore {
  @observable config = {};
  @observable isActive = false;
  @observable
  auditionList = [
    {
      id: 1,
      name: '视频',
      key: 'video',
      link: 'audition-video',
      bg: require('./images/img-shipin.jpg'),
      title: require('./images/text-shipin.png'),
      titleLight: require('./images/text-shipin-l.png'),
      icon: require('./images/icon-shipin.png')
    },
    {
      id: 2,
      name: '图像',
      key: 'image',
      link: 'audition-image',
      bg: require('./images/img-tuxiang.jpg'),
      title: require('./images/text-tuxiang.png'),
      titleLight: require('./images/text-tuxiang-l.png'),
      icon: require('./images/icon-tuxiang.png')
    },
    {
      id: 3,
      name: '音乐',
      key: 'music',
      link: 'audition-audio',
      bg: require('./images/img-yinyue.jpg'),
      title: require('./images/text-yinyue.png'),
      titleLight: require('./images/text-yinyue-l.png'),
      icon: require('./images/icon-yinyue.png')
    }
  ];

  clickNavigate = url => {
    const originUrl = window.location.origin + window.location.pathname + '#/' + url;
    const link = createHtmlLink(originUrl);
    link.target = '_blank';
    link.click();
  };

  constructor({ ...rest } = {}) {
    Object.assign(this, rest);
  }

  use() {
    useMount(() => {});
  }
}
export default AuditionStore;
